<template>
  <div class="nohealth">
    <img src="../assets/image/noData.png"/>
    <div>{{ noText }}</div>
  </div>
</template>
<script>
export default {
    name: 'NoData',
    props: {
      noText: {
        type: String,
        default: '暂无数据'
      }
    },
}
</script>
<style lang="scss" scoped>
.nohealth{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width:320px;
  height: 240px;
  margin: auto;
  text-align: center;
  font-size: 24px;
}
.nohealth img{
  width: 220px;
  height: 200px;
}
.nohealth div{
  margin-top: 20px;
}
</style>